import { toggleClass, removeClass } from "./functions";


class panel {
    _el                     : HTMLDivElement;
    _mediaQuery             : any;
    _elParent               : HTMLDivElement;
    _applyButton            : HTMLButtonElement;
    _panelInit              : boolean;
    _body                   : HTMLElement;
    _togglePanelClassName   : string;
    _overflowHiddenClassName: string;
    _resizeTimeOut          : number;

    constructor(el: HTMLDivElement, applyButton: HTMLButtonElement, mediaQuery?: any) {
        this._el                      = el;
        this._mediaQuery              = mediaQuery;
        this._elParent                = <HTMLDivElement>this._el.parentElement;
        this._applyButton             = applyButton;
        this._panelInit               = false;
        this._resizeTimeOut           = 350;
        this._body                    = document.querySelector("body");
        this._togglePanelClassName    = 'panel-open';
        this._overflowHiddenClassName = 'overflow-hidden';
    }

    // Init accordeon component
    init = () => {
        if(this._mediaQuery){
            if(this._mediaQuery.matches){
                this.run();
            }
        }else {
            this.run();
        }
        // Add window event listener for the resize
        this.windowEvent();
    }

    run = () => {
        if( !this._panelInit ){
            this.addEvent();
            this._panelInit = true;
        }
    }

    // Toggle panel
    togglePanel = () => {
        toggleClass( {domElement: this._elParent, classList: this._togglePanelClassName} );
        toggleClass( {domElement: this._body, classList: this._overflowHiddenClassName} );

        if(this._elParent.classList.contains(this._togglePanelClassName)){
            this._elParent.style.zIndex = "1200";
        }else{
            this._elParent.style.zIndex = null;
        }
    }

    // Window event listener
    windowEvent = () => {
        let timeoutId;
        // Avoid function being called twice on window resize
        window.addEventListener('resize', (e: Event) => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => {
                (this._mediaQuery) ? (this._mediaQuery.matches ? this.run() : this.destroy()) : this.run();
            }, this._resizeTimeOut);
        });        
    }

    // Add event listener
    addEvent = () => {
        // Prev, Next click event
        this._el.addEventListener("click", this.togglePanel, true);
        this._applyButton.addEventListener("click", this.togglePanel, true);
    }    

    // Remove> event listener
    removeEvent = () => {
        // Prev, Next click event
        this._el.removeEventListener("click", this.togglePanel, true);
        this._applyButton.removeEventListener("click", this.togglePanel, true);
    }   

    // Destroy accordeon component
    destroy = () => {
        if( this._panelInit ){
            this.removeEvent();
            removeClass( {domElement: this._elParent, classList: this._togglePanelClassName} );
            removeClass( {domElement: this._body, classList: this._overflowHiddenClassName} );
            this._elParent.style.zIndex = null;
            this._panelInit = false;
        }
    }
}

export default panel;